const getImgSrc = (data: any) => {
    switch (data) {
        case '台风红色': return '/static/warningIcon/taifeng_red.png'
        case '台风橙色': return '/static/warningIcon/taifeng_orange.png'
        case '台风黄色': return '/static/warningIcon/taifeng_yellow.png'
        case '台风蓝色': return '/static/warningIcon/taifeng_blue.png'

        case '暴雨红色': return '/static/warningIcon/baoyu_red.png'
        case '暴雨橙色': return '/static/warningIcon/baoyu_orange.png'
        case '暴雨黄色': return '/static/warningIcon/baoyu_yellow.png'
        case '暴雨蓝色': return '/static/warningIcon/baoyu_blue.png'

        case '暴雪红色': return '/static/warningIcon/baoxue_red.png'
        case '暴雪橙色': return '/static/warningIcon/baoxue_orange.png'
        case '暴雪黄色': return '/static/warningIcon/baoxue_yellow.png'
        case '暴雪蓝色': return '/static/warningIcon/baoxue_blue.png'

        case '寒潮红色': return '/static/warningIcon/hanchao_red.png'
        case '寒潮橙色': return '/static/warningIcon/hanchao_orange.png'
        case '寒潮黄色': return '/static/warningIcon/hanchao_yellow.png'
        case '寒潮蓝色': return '/static/warningIcon/hanchao_blue.png'

        case '大风红色': return '/static/warningIcon/dafeng_red.png'
        case '大风橙色': return '/static/warningIcon/dafeng_orange.png'
        case '大风黄色': return '/static/warningIcon/dafeng_yellow.png'
        case '大风蓝色': return '/static/warningIcon/dafeng_blue.png'

        case '高温红色': return '/static/warningIcon/gaowen_red.png'
        case '高温橙色': return '/static/warningIcon/gaowen_orange.png'
        case '高温黄色': return '/static/warningIcon/gaowen_yellow.png'

        case '雷电红色': return '/static/warningIcon/leidian_red.png'
        case '雷电橙色': return '/static/warningIcon/leidian_orange.png'
        case '雷电黄色': return '/static/warningIcon/leidian_yellow.jpg'

        case '霜冻橙色': return '/static/warningIcon/shuangdong_orange.png'
        case '霜冻黄色': return '/static/warningIcon/shuangdong_yellow.png'
        case '霜冻蓝色': return '/static/warningIcon/shuangdong_blue.png'

        case '大雾红色': return '/static/warningIcon/dawu_red.png'
        case '大雾橙色': return '/static/warningIcon/dawu_orange.png'
        case '大雾黄色': return '/static/warningIcon/dawu_yellow.png'

        case '道路结冰红色': return '/static/warningIcon/daolu_red.png'
        case '道路结冰橙色': return '/static/warningIcon/daolu_orange.png'
        case '道路结冰黄色': return '/static/warningIcon/daolu_yellow.png'

        case '冰雹红色': return '/static/warningIcon/bingbao_red.png'
        case '冰雹橙色': return '/static/warningIcon/bingbao_orange.png'

        case '干旱红色': return '/static/warningIcon/ganhan_red.png'
        case '干旱橙色': return '/static/warningIcon/ganhan_orange.png'

        case '霾红色': return '/static/warningIcon/mai_red.png'
        case '霾橙色': return '/static/warningIcon/mai_orange.png'
        case '霾黄色': return '/static/warningIcon/mai_yellow.png'

        case '森林火险红色': return '/static/warningIcon/huoxian_red.png'
        case '森林火险橙色': return '/static/warningIcon/huoxian_orange.png'
        case '森林火险黄色': return '/static/warningIcon/huoxian_yellow.png'
        case '沙尘暴红色': return '/static/warningIcon/sha_red.png'
        case '沙尘暴橙色': return '/static/warningIcon/sha_orange.png'
        case '沙尘暴黄色': return '/static/warningIcon/sha_yellow.png'
        case '雷暴红色': return '/static/warningIcon/leibao_red.png'
        case '雷暴橙色': return '/static/warningIcon/leibao_orange.png'
        case '雷暴黄色': return '/static/warningIcon/leibao_yellow.png'

        // 补充
        case '雷雨大风红色': return '/static/warningIcon/leiyudafeng_red.jpeg'
        case '雷雨大风橙色': return '/static/warningIcon/leiyudafeng_orange.jpeg'
        case '雷雨大风黄色': return '/static/warningIcon/leiyudafeng_yellow.jpeg'
        case '雷雨大风蓝色': return '/static/warningIcon/leiyudafeng_blue.jpeg'

        case '地质灾害气象风险橙色': return '/static/warningIcon/dizhizaihai_orange.jpg'
        case '地质灾害气象风险黄色': return '/static/warningIcon/dizhizaihai_yellow.png'

        default: return '/static/warningIcon/warn_default.png'
    }
}

export default {getImgSrc}